<script>
	import Search from "./components/Search.svelte";
	import Content from "./components/Content.svelte";

	let stickToTop = true;

	import Data from './data_live_new/faq.json';
  let data = Data.filter(d => (d.question && d.answer));
	let categories = [];
  let categoriesData = [];

	data.forEach((d,i) => {
    d['id'] = String(i);
	});

	export let blocks = {};

	
	data.forEach((v) => {
		blocks[v.id] = {
			'elem': undefined,
			'active': false
		};

		if (!(categories.includes(v.category))) {
			categories.push(v.category)
		}
	});

	export function selectBlock(id, fromSearch) {
		const target = blocks[id].elem;
    blocks[id].active = true;

    Object.keys(blocks).forEach((b) => {
      blocks[b].highlight = false;
    });
    if (fromSearch) {
      blocks[id].highlight = true;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
	}

	export function deselectBlock(id) {
		blocks[id].active = false
    blocks[id].highlight = false;
	}

</script>

<div class="wrapper">
	<Search data={data}
			blocks={blocks} 
			selectBlock={selectBlock}
			{stickToTop} />

	<Content 	data={data} 
				categories={categories}
				blocks={blocks} 
				selectBlock={selectBlock}
				deselectBlock={deselectBlock}/>
</div>

<style lang="scss">
	@import "./main.scss";

	.wrapper {
		// max-width: 620px;
    margin: 50px auto 70px;
    position: relative;
    z-index: 0;
	}

</style>

